<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex>
        <v-card class="rounded-lg">
          <v-toolbar color="#f8f9fb" elevation="0">
            <v-toolbar-title>Change Password</v-toolbar-title>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text class="#f4f5f7">
            <v-form>
              <v-row>
                <v-col cols="12" xs="12" sm="8" md="6">
                  <v-text-field
                    v-model="user.oldPassword"
                    name="Old Password"
                    prepend-icon="mdi-lock-outline"
                    :append-icon="showOldPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showOldPassword ? 'text' : 'password'"
                    label="Old Password"
                    @click:append="showOldPassword = !showOldPassword"
                    v-validate="'required'"
                    :error="errors.first('Old Password') != null || serverSideErrors.oldPassword != null"
                    :error-messages="errors.first('Old Password') || serverSideErrors.oldPassword"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="8" md="6">
                  <v-text-field
                    v-model="user.password"
                    name="password"
                    prepend-icon="mdi-lock-outline"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showPassword ? 'text' : 'password'"
                    label="New Password"
                    @click:append="showPassword = !showPassword"
                    v-validate="'required'"
                    :error="errors.first('password') != null || serverSideErrors.password != null"
                    :error-messages="errors.first('password') || serverSideErrors.password"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="8" md="6">
                  <v-text-field
                    v-model="user.password_confirmation"
                    name="Confirm Password"
                    prepend-icon="mdi-lock-outline"
                    :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showConfirmPassword ? 'text' : 'password'"
                    label="Confirm Password"
                    @click:append="showConfirmPassword = !showConfirmPassword" 
                    v-validate="'required'"
                    :error="errors.first('Confirm Password') != null || serverSideErrors.password_confirmation != null"
                    :error-messages="errors.first('Confirm Password') || serverSideErrors.password_confirmation"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions class="pb-5">
            <v-btn color="secondary" dark class="ml-2 px-8" @click="changePassword" :loading="loading">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations } from 'vuex';
export default {
  data() {
    return {
      loading: false,
      showOldPassword: false,
      showPassword: false,
      showConfirmPassword: false,
      user: {
        oldPassword: '',
        password: '',
        password_confirmation: '',
      },
      serverSideErrors: {},
    };
  },
  methods:{
    ...mapMutations('alert',['setAlert']),
    changePassword() {
      let _self = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _self.loading = true;

          _self.$axios.post('/superadmin/changePassword',this.user)
          .then( response => {
            let data = response.data;

            _self.loading = false;
            _self.serverSideErrors = {};

            if(data.status) {
              data.user.role = 'superadmin';
              localStorage.setItem('user',JSON.stringify(data.user));

              this.setAlert({
                showAlert : true,
                message : data.message,
                variant : 'green accent-4',
                timeout : 2000
              });

              _self.$router.push({ name: 'home' })
            } else {
              if(!data.errors) {
                this.setAlert({
                  showAlert : true,
                  message : data.message,
                  variant : 'red accent-3',
                  timeout : 2000
                });
              } else {
                for(let i=0 ; i<data.errors.length ; i++) {
                  this.serverSideErrors[data.errors[i].field] = data.errors[i].message;
                }
              }
            }
          });
        }
      });
    }
  }
};
</script>